import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DOWNLOAD_OFFLINE_DOCUMENT, GET_OFFLINE_DOCUMENTS, GET_OFFLINE_UPLOADED_DOCUMENT, UPDATE_DOCUMENT_DETAILS, UPDATE_OFFLINE_DOCUMENT, UPLOAD_DOCUMENT_VIA_EC2 } from 'src/app/core/constants/api-endpoints';
import { ACCESS_TOKEN, AUTHORIZATION, BEARER_TOKEN_PREFIX } from 'src/app/core/constants/app-strings';
import { UploadData } from 'src/app/core/model/upload-document.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private http: HttpClient
  ) { }

  validatingOfflineFilesUpload(file: File, docType: string): string {

    if (!file)
      return "Please select a file";

    var idxDot = file ? file.name.lastIndexOf('.') + 1 : null;
    var extFile = file
      ? file.name.substr(idxDot, file.name.length).toLowerCase()
      : null;

    if (!docType)
      return "Select Document Type"

    if (docType === "Application Form" && extFile != "pdf")
      return "Please upload PDF for Application Form";

    if (docType == "PAN" && (extFile != "jpg" && extFile != "jpeg" && extFile != "png"))
      return "Please upload .jpg,.jpeg,.png for PAN";

    if (docType !== 'Application Form' && file.size > 20000000)
      return "Please upload document of size less then 20Mb";

    if (file.size > 20000000)
      return "Please upload document of size less then 20Mb";

    return '';
  }

  uploadDocuments(file: File, uploadData: UploadData) {

    const uploadFormData = new FormData();
    uploadFormData.append('documentType', uploadData.documentType);
    uploadFormData.append('holderUuid', uploadData.holderUuid);
    uploadFormData.append('applicationUuid', uploadData.applicationUuid);
    uploadFormData.append('applicationType', uploadData.applicationType);
    uploadFormData.append('formid', uploadData.formid.toString());
    uploadFormData.append('pdfPageno', uploadData.pdfPageno.toString());
    uploadFormData.append('applicationStatus', uploadData.applicationStatus);
    uploadFormData.append('file', file, file?.name);

    const url = `${environment.LINUX}${UPLOAD_DOCUMENT_VIA_EC2}`;
    // const url = `${'https://swift.eaaa.in/prod'}${UPLOAD_DOCUMENT_VIA_EC2}`;


    return this.http.post(
      url,
      uploadFormData
    )
  }

  updateDocumentDetails(body: any) {

    const url = `${environment.APIURL}${UPDATE_DOCUMENT_DETAILS}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(
      url,
      body,
      { headers }
    );

  }

  getOfflineDocumentByInvestorId(investorId: number) {
    const url = `${environment.APIURL}${GET_OFFLINE_DOCUMENTS}${investorId}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(
      url,
      { headers }
    );
  }

  getOfflineUploadedDocument(formId: string) {
    const url = `${environment.APIURL}${GET_OFFLINE_UPLOADED_DOCUMENT}${formId}`;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers })
  }

  updateOfflineDocument(body: any) {
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = `${environment.APIURL}${UPDATE_OFFLINE_DOCUMENT}`;
    return this.http.post(url, body, { headers })
  }

  downloadOfflineDocument(body: any) {
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = `${environment.APIURL}${DOWNLOAD_OFFLINE_DOCUMENT}`;
    return this.http.post(url, body, { headers })
  }
}
